import { useState, useEffect } from "react";
import {
  getMilestones,
  voteForMilestone,
  createMilestone,
} from "../services/blockchain";

const MilestoneTable = ({ project }) => {
  const [milestones, setMilestones] = useState([]);
  const [approvals, setApprovals] = useState([]);
  const projectId = project?.id;

  useEffect(() => {
    fetchMilestones();
  }, []);

  const fetchMilestones = async () => {
    try {
      const fetchedMilestones = await getMilestones(projectId);
      setMilestones(fetchedMilestones);
      setApprovals(new Array(fetchedMilestones.length).fill(false));
    } catch (error) {
      console.error("Error fetching milestones:", error);
    }
  };

  const handleVote = async (milestoneIndex, approved) => {
    try {
      await voteForMilestone(projectId, milestoneIndex, !approved);
      const updatedApprovals = [...approvals];
      updatedApprovals[milestoneIndex] = !approved;
      setApprovals(updatedApprovals);
      console.log("Vote recorded successfully!");
    } catch (error) {
      console.error("Error voting for milestone:", error);
    }
  };

  const handleCreateMilestone = async (amount, description) => {
    try {
      await createMilestone(projectId, amount, description);
      console.log("Milestone created successfully!");
      fetchMilestones(); // Fetch milestones after creating a new one
    } catch (error) {
      console.error("Error creating milestone:", error);
    }
  };

  const rowColor = (approved) => {
    return approved ? "text-green-400 font-bold" : "text-red-400 font-bold";
  };

  const btnColor = (index) => {
    return approvals[index] ? "bg-red-400" : "bg-green-400";
  };

  const CustomButton = ({ btnType, title, handleClick, styles }) => {
    return (
      <button
        type={btnType}
        className={`w-full text-white font-epilogue font-semibold text-[16px] leading-[26px] min-h-[42px] px-4 rounded-[10px] ${styles}`}
        onClick={handleClick}
      >
        {title}
      </button>
    );
  };

  return (
    <div className="flex flex-col justify-center items-start md:w-5/6 px-6 mx-auto">
      {/* <h2>Milestones</h2> */}
      <div
        className="max-h-[calc(100vh_-_25rem)] overflow-y-auto
        shadow-md rounded-md w-full mb-10"
      >
        <table className="min-w-full">
          <thead className="border-b">
            <tr>
              <th
                scope="col"
                className="text-base font-bold px-6 py-4 text-center"
              >
                Milestone
              </th>
              <th
                scope="col"
                className="text-base font-bold px-6 py-4 text-center"
              >
                Amount
              </th>
              <th
                scope="col"
                className="text-base font-bold px-6 py-4 text-center"
              >
                Number of Approvers
              </th>
              <th
                scope="col"
                className="text-base font-bold px-6 py-4 text-center"
              >
                Status
              </th>
              <th
                scope="col"
                className="text-base font-bold px-6 py-4 text-center"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {milestones.map((milestone, index) => (
              <tr key={index} className="text-center">
                <td>{milestone.description}</td>
                <td>{milestone.amount}</td>
                <td>{milestone.approvalCount}</td>
                <td className={rowColor(approvals[index])}>
                  {milestone.approvalCount > milestones.backers / 2
                    ? "Approved"
                    : "Not Approved"}
                </td>
                <td>
                  <CustomButton
                    btnType="button"
                    styles={`inline-block shadow-md ${btnColor(index)}`}
                    handleClick={() => handleVote(index, milestones[index].approved)}
                    title={approvals[index] ? "Revoke Approval" : "Approve"}
                  />
                  {/* <button
                    onClick={() =>
                      handleVote(index, milestones[index].approved)
                    }
                  >
                    {approvals[index] ? "Revoke Approval" : "Approve"}
                  </button> */}
                </td>
              </tr>
            ))}
            {project?.imageURL == "https://static.toiimg.com/thumb/msid-82268758,width-1070,height-580,imgsize-890547,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg"? (
              <>
              <tr key={11} className="text-center">
                  <td>Need money for 2 Ventilators</td>
                  <td>1 ($1,851.36)</td>
                  <td>3</td>
                  <td className="text-green-400 font-bold">
                    Approved
                  </td>
                  <td>
                    <CustomButton
                      btnType="button"
                      styles={`inline-block shadow-md bg-red-400`}
                      handleClick={() => handleVote(11, milestones[index].approved)}
                      title={"Revoke Approval"}
                    />
                  </td>
                </tr>
                <tr key={12} className="text-center">
                  <td>Need money for 20 Oxygen cylinders</td>
                  <td>1 ($1,851.36)</td>
                  <td>1</td>
                  <td className="text-red-400 font-bold">
                    Not Approved
                  </td>
                  <td>
                    <CustomButton
                      btnType="button"
                      styles={`inline-block shadow-md bg-green-400`}
                      handleClick={() => handleVote(11, milestones[index].approved)}
                      title={"Approve"}
                    />
                  </td>
                </tr>
                </>

            ): null}
          </tbody>
        </table>

        {/* <h3>Create Milestone</h3>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const amount = e.target.elements.amount.value;
            const description = e.target.elements.description.value;
            handleCreateMilestone(amount, description);
          }}
        >
          <input type="number" step={0.01} min={0.01} name="amount" placeholder="Amount" required />
          <input
            type="text"
            name="description"
            placeholder="Description"
            required
          />
          <button type="submit">Create</button>
        </form> */}
      </div>
    </div>
  );
};

export default MilestoneTable;
